import { EntityType } from '@frontend/common';
import { EventClient } from '@frontend/events/api';
import { EventLevel, EventType } from '@frontend/events/types';
import { useEffect, useState } from 'react';

import { TransactionHistoryModalProps } from './transaction-history-modal.component';

interface ViewProps {
    isLoading: boolean;
    isEmpty: boolean;
}

const useTransactionHistoryModal = (props: TransactionHistoryModalProps): ViewProps => {
    const [isLoading, setIsLoading] = useState(true);
    const [isEmpty, setIsEmpty] = useState(false);

    useEffect(() => {
        if (!props.show || !props.transactionId) {
            return;
        }

        let cancelled = false;
        setIsLoading(true);
        EventClient.fetchEntityEvents(EntityType.TRANSACTION, props.transactionId, {
            index: '0',
            size: '1',
            level: [EventLevel.INFO, EventLevel.ERROR],
            type: [EventType.TRANSACTION_HISTORY_LOGGED, EventType.NOTIFICATION_SENT]
        })
            .then((res) => {
                if (!cancelled) {
                    setIsEmpty(res.count === 0);
                    setIsLoading(false);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setIsEmpty(true);
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.show, props.transactionId]);

    return { isLoading, isEmpty };
};

export default useTransactionHistoryModal;
